export default {
  "b2b.doplnkove-sluzby-grid.id.label": "Id",
  "b2b.doplnkove-sluzby-grid.nazev.label": "Name",
  "b2b.doplnkove-sluzby-grid.popis.label": "Description",
  "b2b.doplnkove-sluzby-grid.zkratka.label": "Abbreviation",
  "b2b.doplnkove-sluzby-grid.uzivaNapajeni.label": "It uses power",
  "b2b.doplnkove-sluzby-grid.vylucny.label": "Exclusive"
};
